import {
  startsWith, concat, includes,
} from 'ramda';

export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber || !includes('+1', phoneNumber)) {
    return phoneNumber;
  }
  const cleaned = phoneNumber?.replace('+1', '');
  const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `+1 (${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};

type CountryCode = 'US' | 'UK' | 'Canada' | 'Aruba' | 'Mexico' | 'Brazil';

const phoneMasks: Record<CountryCode, string> = {
  US: '+1 (000) 000-0000',
  UK: '+44 0000 000000',
  Canada: '+1 (000) 000-0000',
  Aruba: '+297 000 0000',
  Mexico: '+52 000 000 0000',
  Brazil: '+55 (00) 00000-0000',
};

const countryCodePrefixes = {
  US: '+1',
  Canada: '+1',
  UK: '+44',
  Aruba: '+297',
  Mexico: '+52',
  Brazil: '+55',
};

export const handlePlus = (phoneNumber: string) => {
  for (const prefix in countryCodePrefixes) {
    if (startsWith(countryCodePrefixes[prefix as CountryCode].replace('+', ''), phoneNumber)) {
      return concat('+', phoneNumber);
    }
  }
  return phoneNumber;
};

const detectCountryCode = (phoneNumber: string) => {
  for (const prefix in countryCodePrefixes) {
    if (startsWith(countryCodePrefixes[prefix as CountryCode], phoneNumber)) {
      return prefix;
    }
  }

  return '';
};

export const getPhoneMask = (phoneNumber: string, showUSCode = true): string => {
  if (!phoneNumber) {
    return '';
  }
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  const countryCode = detectCountryCode(phoneNumber);
  if (!countryCode) {
    if (phoneNumber.length > 3 && showUSCode) {
      return getPhoneMask(concat('+1', cleanedNumber));
    }
    return startsWith('+', phoneNumber) ? concat('+', cleanedNumber) : cleanedNumber;
  }
  const mask = phoneMasks[countryCode as CountryCode];
  let index = countryCodePrefixes[countryCode as CountryCode].length - 1;
 
  const maskedNumber = mask.split('').map((digit) => {
    if (digit === '0') {
      index += 1;
      return cleanedNumber[index - 1];
    }
    return digit;
  }).join('');
  if (!showUSCode && countryCode === 'US') {
    return maskedNumber.replace('+1 ', '');
  }
  return maskedNumber;
};
